/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import moment from 'moment-timezone';
import { Link } from 'react-router';
import ajax from '../../../../components/ajax';
import auth from '../../../../components/auth';
import { gql, useMutation } from '@apollo/client';
import _ from 'lodash';
import * as Enums from '@playbook-technologies/common-enums';
import { AnyFn } from '../../../../new/helpers/types';
import { PATHS } from '@client/routes';
import { InfluencerIdContext } from '@client/new/contexts/InfluencerIdContext';
import { getWorkoutDeepLink } from '@client/new/pages/collection/workouts/workout.query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareNodes } from '@fortawesome/pro-light-svg-icons';
import { WorkoutLinkModal } from '@client/new/pages/collection/workouts/WorkoutLinkModal';

type WorkoutListItemProps = {
  // NOTE: might lie a little some of ? might be unnecessary
  totalWorkouts?: number;
  collection: {
    isLocked: boolean;
    workoutLimit?: number | null;
    contentStructure?: string | null;
  };
  index?: number;
  displayWeekDaySelect?: boolean;
  type: string;
  onMoveUp?: AnyFn;
  onMoveDown?: AnyFn;
  onChange: AnyFn;
  onWeekDaySelect?: AnyFn;
  programColor: string; // NOT sure if needed
  displayOrderingButtons: boolean;
  isHidden?: boolean;
  workout: {
    id: number;
    isClass: boolean;
    isProtected: boolean;
    name: string;
    publishedAt: string;
    archivedAt: string;
    statsBegins: number;
    statsRatingAverage: number;
    statsComments: number;
    programId: number;
    programName: string;
    programColor: string;
    programIsOtp: boolean;
    programIsLocked: boolean;
    updatedAt: string;
  };
  influencerId: number;
};

function removeWeekDay(title: string) {
  return title.replace(/^(W\d+|D\d+|W\d+\/D\d+) /, '');
}

export class WorkoutListItem extends React.Component<
  WorkoutListItemProps,
  { workoutDeepLinkModal: { isOpen: boolean; url: string }; message: string }
> {
  constructor(props: WorkoutListItemProps) {
    super(props);
    this.cloneWorkout = this.cloneWorkout.bind(this);
    this.deleteWorkout = this.deleteWorkout.bind(this);
    this.getRatingNumber = this.getRatingNumber.bind(this);

    this.state = {
      workoutDeepLinkModal: { isOpen: false, url: '' },
      message: '',
    };
  }

  declare context: React.ContextType<typeof InfluencerIdContext>;
  static contextType = InfluencerIdContext;

  toCoolDateTime(iso8601: string) {
    return moment(iso8601).format('MMM D YYYY, h:mma');
  }
  cloneWorkout(id: number) {
    const answer = confirm('Are you sure you want to *clone* this Workout?');
    if (answer) {
      ajax
        .cloneWorkout(id)
        .then(() => {
          this.props.onChange();
        })
        .catch((e) => {
          if (e === 'auth') {
            auth.logout();
          } else {
            this.setState({
              message: 'You may be experiencing connectivity issues.',
            });
          }
        });
    }
  }
  archiveWorkout(id: number) {
    const answer = confirm('Are you sure you want to *archive* this Workout?');
    if (answer) {
      //console.log('Attempting to archive ' + id);
      ajax
        .archiveWorkout(id)
        .then(() => {
          this.props.onChange();
        })
        .catch((e) => {
          if (e === 'auth') {
            auth.logout();
          } else {
            this.setState({
              message: 'You may be experiencing connectivity issues.',
            });
          }
        });
    }
  }
  deleteWorkout(id: number) {
    const answer = confirm('Are you sure you want to *delete* this Workout?');
    if (answer) {
      ajax
        .deleteWorkout(id)
        .then(() => {
          this.props.onChange();
        })
        .catch((e) => {
          console.log('[WorkoutListItem] Error deleting Workout.', e);
          if (e === 'auth') {
            auth.logout();
          }
          //TODO wire up some user-viewable error message
        });
    }
  }

  openWorkoutDeepLinkModal(workoutId: number) {
    getWorkoutDeepLink(workoutId).then((data) => {
      this.setState({
        workoutDeepLinkModal: {
          isOpen: true,
          url: data.url,
        },
      });
    });
  }
  getRatingNumber(num: unknown) {
    if (!num) return '0.00';
    const s = Math.round(this.props.workout.statsRatingAverage * 100);
    if (s % 100 === 0) return s / 100 + '.00';
    if (s % 10 === 0) return s / 100 + '0';
    else return s / 100;
  }
  render() {
    const isValidContext = typeof this.context === 'number' && this.context > 0;
    if (!isValidContext) {
      throw new Error(
        'InfluencerIdContext is not set! Make sure to wrap this WorkoutListItem with InfluencerIdProvider.',
      );
    }

    const commentLink = `/admin/${this.props.influencerId}/workout/${this.props.workout.id}/comments`;
    const editLink = this.props.workout.isClass
      ? PATHS.CLASS_EDIT({
          influencerId: this.context,
          workoutId: this.props.workout.id,
        })
      : PATHS.WORKOUT_EDIT({
          influencerId: this.context,
          workoutId: this.props.workout.id,
        });
    const editArchivedLink = PATHS.WORKOUT_EDIT({
      influencerId: this.context,
      workoutId: this.props.workout.id,
      view: 'archive',
    });

    const isProtected = this.props.workout.isProtected ? (
      ''
    ) : (
      <span style={{ color: '#24ba7c', fontWeight: 'bold' }}>FREE&nbsp;</span>
    );
    let channelBadge = null;
    if (
      this.props.workout.programId &&
      this.props.workout.programName &&
      this.props.type !== 'program'
    ) {
      channelBadge = (
        <div
          className="channelBadge"
          style={{ background: `#${this.props.workout.programColor}` }}
        >
          {this.props.workout.programName}
        </div>
      );
    }

    if (this.props.type === 'draft') {
      let draftChannelColumn: JSX.Element | '' = '';
      if (this.props.workout.programId) {
        draftChannelColumn = (
          <small>
            <span>{channelBadge}</span>
            <span>
              <strong>&nbsp;</strong>
            </span>
            <span>
              <strong>&nbsp;</strong>
            </span>
          </small>
        );
      }
      return (
        <li className="draft" key={this.props.workout.id}>
          <WorkoutThumbnailImg workout={this.props.workout} />
          <strong>
            {this.props.workout.name}
            <br />
            <time>
              Last edited {this.toCoolDateTime(this.props.workout.updatedAt)}
            </time>
          </strong>
          <div></div>
          {this.props.workout.programId ? null : <div></div>}
          {draftChannelColumn}
          <span className="toolbox">
            <Link className="icon icon-edit" to={editLink}></Link>
            <a
              className="actionLink icon icon-duplicate"
              onClick={() => this.cloneWorkout(this.props.workout.id)}
            ></a>
            <a
              className="actionLink icon icon-trash"
              onClick={() => this.deleteWorkout(this.props.workout.id)}
            ></a>
          </span>
        </li>
      );
    } else if (this.props.type === 'scheduled') {
      return (
        <li className="scheduled" key={this.props.workout.id}>
          <WorkoutThumbnailImg workout={this.props.workout} />
          <strong>
            {this.props.workout.name}
            <br />
            <time>
              {isProtected}Last edited on{' '}
              {this.toCoolDateTime(this.props.workout.updatedAt)}
            </time>
          </strong>
          <small>
            <span>{channelBadge}</span>
            <span className="publishing">
              <strong>Publishing</strong>{' '}
              <div className="whitespace-nowrap">
                {this.toCoolDateTime(this.props.workout.publishedAt)}
              </div>
            </span>
          </small>
          <span className="toolbox">
            <Link className="icon icon-edit" to={editLink}></Link>
            <a
              className="actionLink icon icon-duplicate"
              onClick={() => this.cloneWorkout(this.props.workout.id)}
            ></a>
            {(!this.props.workout.programIsOtp ||
              !this.props.workout.programIsLocked) && (
              <a
                className="actionLink icon icon-archive"
                onClick={() => this.archiveWorkout(this.props.workout.id)}
              ></a>
            )}
          </span>
        </li>
      );
    } else if (this.props.type === 'channel') {
      const statSection = (
        <small>
          <span className="flex-left">
            <mark>
              {this.props.workout.statsBegins
                ? this.props.workout.statsBegins
                : 0}
            </mark>{' '}
            begins
          </span>
          <span className="flex-left">
            <mark>
              {this.getRatingNumber(this.props.workout.statsRatingAverage)}
            </mark>{' '}
            rating
          </span>
          {this.props.workout.statsComments ? (
            <span className="flex-left">
              <mark>{this.props.workout.statsComments}</mark> comments
            </span>
          ) : (
            <span className="disabled-link flex-left">0 comments</span>
          )}

          <Link
            className="active-link flex-left"
            style={{ color: `#${this.props.programColor}` }}
            to={commentLink}
          >
            live view
          </Link>
        </small>
      );
      return (
        <li className="channel" key={this.props.workout.id}>
          <WorkoutThumbnailImg workout={this.props.workout} />
          <strong>
            {this.props.workout.name}
            <br />
            <time>
              {isProtected}Published on{' '}
              {this.toCoolDateTime(this.props.workout.publishedAt)}
            </time>
          </strong>
          <span>{channelBadge}</span>
          {statSection}
          <span className="toolbox">
            <Link className="icon icon-edit" to={editLink}></Link>
            <a
              className="actionLink icon icon-duplicate"
              onClick={() => this.cloneWorkout(this.props.workout.id)}
            ></a>
            <a
              className="actionLink icon icon-archive"
              onClick={() => this.archiveWorkout(this.props.workout.id)}
            ></a>
          </span>
        </li>
      );
    } else if (this.props.type === 'program') {
      let buttons = [];

      const isLockedForUser =
        !(auth.isAdministrator() || auth.isModerator()) &&
        this.props.collection.isLocked;

      const shouldDisplayArrows =
        !isLockedForUser &&
        !(
          this.props.collection?.workoutLimit ||
          this.props.collection?.contentStructure ===
            Enums.Program.ContentStructure.Dayweek.value
        );
      if (shouldDisplayArrows && this.props.index > 0) {
        if (this.props.index < this.props.totalWorkouts - 1) {
          buttons = [
            <a
              className="actionLink icon icon-arrow-up"
              key="1"
              onClick={() => this.props.onMoveUp(this.props.index)}
            ></a>,
            <a
              className="actionLink icon icon-arrow-down"
              key="2"
              onClick={() => this.props.onMoveDown(this.props.index)}
            ></a>,
          ];
        } else {
          buttons = [
            <div
              key="1"
              style={{
                display: 'inline-block',
                width: '25px',
                height: '25px',
                marginLeft: '10px',
              }}
            ></div>,
            <a
              key="2"
              className="actionLink icon icon-arrow-up"
              onClick={() => this.props.onMoveUp(this.props.index)}
            ></a>,
          ];
        }
      } else if (shouldDisplayArrows) {
        buttons = [
          <div
            key="1"
            style={{
              display: 'inline-block',
              width: '25px',
              height: '25px',
              marginLeft: '10px',
            }}
          ></div>,
          <a
            key="2"
            className="actionLink icon icon-arrow-down"
            onClick={() => this.props.onMoveDown(this.props.index)}
          ></a>,
        ];
      }

      const statSection = (
        <small>
          <span className="flex-left">
            <mark>
              {this.props.workout.statsBegins
                ? this.props.workout.statsBegins
                : 0}
            </mark>{' '}
            begins
          </span>
          <span className="flex-left">
            <mark>
              {this.getRatingNumber(this.props.workout.statsRatingAverage)}
            </mark>{' '}
            rating
          </span>
          {this.props.workout.statsComments ? (
            <span className="flex-left">
              <mark>{this.props.workout.statsComments}</mark> comments
            </span>
          ) : (
            <span className="disabled-link flex-left">0 comments</span>
          )}

          <Link
            className="active-link flex-left"
            style={{ color: `#${this.props.programColor}` }}
            to={commentLink}
          >
            view
          </Link>
        </small>
      );
      let index: JSX.Element | string = '';
      let color = '#d0d0d0';
      if (this.props.programColor && this.props.programColor.length === 6) {
        color = `#${this.props.programColor}`;
      }
      if (typeof this.props.index === 'number' && !this.props.isHidden) {
        index = (
          <span
            style={{
              display: 'inline-block',
              borderRadius: '5px',
              width: '30px',
              height: '30px',
              background: color,
              color: '#fff',
              lineHeight: '30px',
              textAlign: 'center',
              marginRight: '10px',
              fontWeight: 'bold',
            }}
          >
            {this.props.index + 1}
          </span>
        );
      }

      return (
        <li
          className="program"
          key={this.props.workout.id}
          style={{ opacity: this.props.isHidden ? '0.8' : '1' }}
        >
          <WorkoutThumbnailImg workout={this.props.workout} />
          <WorkoutLinkModal
            isOpen={this.state.workoutDeepLinkModal.isOpen}
            onClose={() =>
              this.setState({
                workoutDeepLinkModal: { isOpen: false, url: '' },
              })
            }
            url={this.state.workoutDeepLinkModal.url}
          />
          {this.props.displayWeekDaySelect ? (
            <WorkoutWeekDaySelect
              workout={this.props.workout}
              color={color}
              onSelect={this.props.onWeekDaySelect as any}
            />
          ) : (
            index
          )}
          <strong>
            {this.props.displayWeekDaySelect
              ? removeWeekDay(this.props.workout.name)
              : this.props.workout.name}
            <br />
            <time>
              {isProtected}Published on{' '}
              {this.toCoolDateTime(this.props.workout.publishedAt)}
            </time>
          </strong>
          {statSection}
          <span className="toolbox">
            {buttons[0]}
            {buttons[1]}
            <Link className="icon icon-edit" to={editLink}></Link>
            <a
              className="actionLink icon icon-duplicate"
              onClick={() => this.cloneWorkout(this.props.workout.id)}
            ></a>
            <a
              className="actionLink icon icon-share"
              onClick={() =>
                this.openWorkoutDeepLinkModal(this.props.workout.id)
              }
            >
              <FontAwesomeIcon icon={faShareNodes} />
            </a>
            {!isLockedForUser && (
              <a
                className="actionLink icon icon-archive"
                onClick={() => this.archiveWorkout(this.props.workout.id)}
              ></a>
            )}
          </span>
        </li>
      );
    } else if (this.props.type === 'archived') {
      let forceArchived = '';
      if (
        (window as any) &&
        (window as any).data &&
        ((window as any).data.environment === 'development' ||
          (window as any).data.environment === 'integration') &&
        this.props.workout.archivedAt
      ) {
        forceArchived = ' 💣';
      }
      const statSection = (
        <small>
          <span>{channelBadge}</span>
          <span className="flex-left">
            <mark>
              {this.props.workout.statsBegins
                ? this.props.workout.statsBegins
                : 0}
            </mark>{' '}
            begins
          </span>
          <span className="flex-left">
            <mark>
              {this.getRatingNumber(this.props.workout.statsRatingAverage)}
            </mark>{' '}
            rating
          </span>
          {this.props.workout.statsComments ? (
            <span className="flex-left">
              <mark>{this.props.workout.statsComments}</mark> comments
            </span>
          ) : (
            <span className="disabled-link flex-left">0 comments</span>
          )}

          <Link
            className="active-link flex-left"
            style={{ color: `#${this.props.programColor}` }}
            to={commentLink}
          >
            view
          </Link>
        </small>
      );
      return (
        <li className="archived" key={this.props.workout.id}>
          <WorkoutThumbnailImg workout={this.props.workout} />
          <strong>
            {this.props.workout.name}
            {forceArchived}
            <br />
            <time>
              {isProtected}
              Archived at: {this.toCoolDateTime(this.props.workout.archivedAt)}
            </time>
          </strong>
          {statSection}
          <span className="toolbox">
            <Link className="icon icon-edit" to={editArchivedLink}></Link>
            <a
              className="actionLink icon icon-duplicate"
              onClick={() => this.cloneWorkout(this.props.workout.id)}
            ></a>
            {!this.props.workout.programIsOtp && (
              <a
                className="actionLink icon icon-trash"
                onClick={() => this.deleteWorkout(this.props.workout.id)}
              ></a>
            )}
          </span>
        </li>
      );
    } else return null;
  }
}

function WorkoutThumbnailImg({ workout }: any) {
  return null; // Removed till we get static images
  const imgSrc = toImgSrc(workout.media);
  return (
    <div
      style={{
        minHeight: '100px',
        minWidth: '60px',
        background: imgSrc ? 'inherit' : 'black',
        borderTopLeftRadius: imgSrc ? 'inherit' : '5px',
        borderBottomLeftRadius: imgSrc ? 'inherit' : '5px',
      }}
    >
      {imgSrc ? (
        <img
          className="workoutThumbnail"
          width="60px"
          height="100px"
          style={{
            objectFit: 'cover',
          }}
          src={imgSrc}
        />
      ) : null}
    </div>
  );
}

function toImgSrc(media) {
  if (!media) return null;
  if (media?.videoThumbnailUrl) return media.videoThumbnailUrl;
  if (!media.image) return null;
  if (!media.cdn01) return media.image;

  return media.cdn01 + media.image;
}

type IWorkoutWeekDaySelect = {
  color: string;
  workout: {
    name: string;
  };
  onSelect: (w: { id: number; name: string }) => void;
};
function WorkoutWeekDaySelect({
  onSelect,
  color,
  workout,
}: IWorkoutWeekDaySelect) {
  // https://app.shortcut.com/playbook/story/53692/admin-panel-week-day-input-from-program-overview
  const weekMatch = workout.name.match(/^W(\d+)/);
  const dayMatch =
    workout.name.match(/^W\d+\/D(\d+)/) || workout.name.match(/^D(\d+)/);
  const week = weekMatch ? weekMatch[1] : null;
  const day = dayMatch ? dayMatch[1] : null;

  const [dayValue, setDayValue] = useState(day);
  const [weekValue, setWeekValue] = useState(week);

  const [updateWorkoutName] = useMutation(
    gql`
      mutation UpdateWorkoutName($workoutId: Int!, $name: String!) {
        updateWorkoutName(workoutId: $workoutId, name: $name) {
          id
          name
        }
      }
    `,
  );

  const setWorkoutName = (workout, updatedWeekDay: string) => {
    const currentName = workout.name;
    const updatedName = `${updatedWeekDay} ${removeWeekDay(currentName)}`;

    updateWorkoutName({
      variables: {
        workoutId: workout.id,
        name: updatedName,
      },
    });

    onSelect({ ...workout, name: currentName });
  };

  const updateWeekInName = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const changedWeek = e.target.value;
    if (changedWeek === '') return;

    setWeekValue(changedWeek);
    const updatedWeek = dayValue
      ? `W${changedWeek}/D${dayValue}`
      : `W${changedWeek}`;
    setWorkoutName(workout, updatedWeek);
  };

  const updateDayInName = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const changedDay = e.target.value;
    if (changedDay === '') return;

    setDayValue(changedDay);
    const updatedName = weekValue
      ? `W${weekValue}/D${changedDay}`
      : `D${changedDay}`;
    setWorkoutName(workout, updatedName);
  };

  const enableDaySelect =
    dayValue !== null || (dayValue === null && weekValue !== null);

  return (
    <div className="flex">
      <select
        style={{
          background: weekValue === null ? color : 'inherit',
          color: weekValue === null ? 'white' : 'black',
          borderRadius: '6px',
          fontSize: '15px',
          width: '70px',
          marginRight: '10px',
        }}
        name="week"
        value={weekValue ? weekValue : ''}
        onChange={updateWeekInName}
      >
        <option value="" disabled>
          W?
        </option>
        {[
          ...Array(20)
            .fill(0)
            .map((_, i) => i + 1),
        ].map((w) => (
          <option key={w} value={String(w)}>
            W{w}
          </option>
        ))}
      </select>
      <select
        style={{
          background: dayValue === null ? color : 'inherit',
          color: dayValue === null ? 'white' : 'black',
          borderRadius: '6px',
          fontSize: '15px',
          width: '70px',
        }}
        name="day"
        value={dayValue ? dayValue : ''}
        onChange={updateDayInName}
        disabled={!enableDaySelect}
      >
        <option value="" disabled>
          D?
        </option>
        {[1, 2, 3, 4, 5, 6, 7].map((d) => (
          <option key={d} value={String(d)}>
            D{d}
          </option>
        ))}
      </select>
    </div>
  );
}
